const getShimmerLoadingData = (quantity, columns) =>
  Array.from({ length: quantity }).map(() => columns.reduce((item, column) => ({ ...item, [column.key]: null }), {}));

export default getShimmerLoadingData;
